"use client"

import { createBrowserClient } from "@supabase/ssr"
import type { SupabaseClient } from "@supabase/supabase-js"

// Stash the client on globalThis so HMR (and accidental re-imports under
// turbopack) reuse a single instance. Multiple instances fight for the
// auth navigator lock and produce the "Lock broken … steal" warning,
// plus they desync session state.
const GLOBAL_KEY = "__databridgeSupabaseBrowserClient__"
type Globals = typeof globalThis & { [GLOBAL_KEY]?: SupabaseClient }

function getClient(): SupabaseClient {
  const g = globalThis as Globals
  if (g[GLOBAL_KEY]) return g[GLOBAL_KEY]!

  const client = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL ?? "",
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? "",
  )
  g[GLOBAL_KEY] = client
  return client
}

export const supabase = getClient()
